//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import {
  ContentCard,
  DetailLabel,
  DetailRow,
} from '@campaigns/components/campaign-requests/sampling-campaigns/edit/shared/quote-section/SamplingCampaignRequestQuoteSharedStyles';
import Icon from '@components/atoms/icon/Icon';
import {
  BodyBoldText,
  BodyText,
  CaptionText,
} from '@components/atoms/text/Text';

export const SamplingCampaignRequestClientFulfillmentSummary = () => {
  return (
    <ContentCard>
      <BodyBoldText>Delivery</BodyBoldText>

      <DetailRow>
        <DetailLabel>
          <Icon name='box-open' />
          <CaptionText>Packages</CaptionText>
        </DetailLabel>
        <BodyText>Shipped by you</BodyText>
      </DetailRow>
    </ContentCard>
  );
};
